import React from "react";

const Seleccionepack = () => {
  return <div>Seleccionepack</div>;
};

export default Seleccionepack;
